export function isSettlementStatusVoid(status) {
    return status === "Cancelled" || status === "Void";
}
//# sourceMappingURL=isSettlementStatusVoid.js.map